module.exports = __webpack_public_path__ + "img/noti-phone-full.4ebc42cc.png";